import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M-47.614-470.2l-10.743,10.743a5.849,5.849,0,0,0-5.665,1.509,5.856,5.856,0,0,0,0,8.282,5.857,5.857,0,0,0,8.282,0,5.841,5.841,0,0,0,1.646-4.992l3.951-3.951-2.093-2.093,1.433-1.434,2.093,2.093,2.005-2.005-1.549-1.549,1.437-1.437,1.549,1.548,2.184-2.184.154-4.685Zm-13.467,18.34a1.723,1.723,0,0,1-2.437,0,1.723,1.723,0,0,1,0-2.437,1.723,1.723,0,0,1,2.437,0A1.723,1.723,0,0,1-61.081-451.861Z"
    transform="translate(65.738 470.355)"
  />,
  '0 0 22.808 22.403'
);
